import { ChangeDetectionStrategy, Component, NO_ERRORS_SCHEMA, ViewChild } from '@angular/core';
import { DeviceBaseComponent } from '../../device-base/device-base.component';
import { NgIf, NgClass } from '@angular/common';

@Component({
  selector: 'app-yealink-t46',
  templateUrl: './yealink-t46.component.html',
  styleUrls: ['../../device-base/device-base.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [DeviceBaseComponent, NgIf, NgClass],
  schemas: [NO_ERRORS_SCHEMA],
})
export class YealinkT46Component {
  @ViewChild('base') base!: DeviceBaseComponent;

  public readonly buttonsLimit = 27;
}
